import AreasIndexForm from './AreasIndexForm';

export default AreasIndexForm;
